import { render } from "./Sidebar.vue?vue&type=template&id=4837751d&scoped=true"
const script = {}

import "./Sidebar.vue?vue&type=style&index=0&id=4837751d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4837751d"]])

export default __exports__